import Splide from '@splidejs/splide';
//DOM loaded
document.addEventListener("DOMContentLoaded", () => {

    //Carousel init
    let carousel = document.querySelectorAll('.pdw-carousel');
    let carouselArray = new Object();

    carousel.forEach((item, index) => {
        let dataPerviewDefault = parseInt(item.dataset.perview);
        let dataPerview = {
            9999: parseInt(item.dataset.perviewxxl),
            1399: parseInt(item.dataset.perviewxl),
            1199: parseInt(item.dataset.perviewlg),
            991: parseInt(item.dataset.perviewmd),
            767: parseInt(item.dataset.perviewsm),
            575: parseInt(item.dataset.perviewxs)
        }
        let breakPoints = {};
        Object.keys(dataPerview).forEach(key => {
            if (Number.isInteger(dataPerview[key])) {
                breakPoints[key] = {
                    perPage: dataPerview[key]
                };
            } else {
                if (key === '767') {
                    breakPoints[key] = {
                        perPage: 1
                    };
                }
                if (key === '991') {
                    breakPoints[key] = {
                        perPage: (dataPerviewDefault > 1) ? dataPerviewDefault - 1 : 1
                    };
                }
            }
        });
        let dataType = 'loop';
        if ("type" in item.dataset) {
            dataType = item.dataset.type;
        }
        let dataGap = parseInt(item.dataset.gap);
        let dataPeekBefore = 0;
        if ("peekbefore" in item.dataset) {
            dataPeekBefore = parseInt(item.dataset.peekbefore);
        }
        let dataPeekAfter = 0;
        if ("peekafter" in item.dataset) {
            dataPeekAfter = parseInt(item.dataset.peekafter);
        }
        let conf = {
            type: dataType,
            arrows: true,
            pagination: true,
            rewind: false,
            perPage: dataPerviewDefault,
            perMove: 1,
            gap: dataGap + 'px',
            autoplay: false,
            breakpoints: breakPoints,
            padding: {
                left: dataPeekBefore,
                right: dataPeekAfter
            }
        }

        carouselArray['carousel' + index] = new Splide(item, conf);

        let carouselCounter = item.querySelectorAll('.pdw-carousel-counter > .splide');
        if (carouselCounter.length > 0) {
            let confCounter = {
                perPage: 1,
                type: 'fade',
                rewind: true,
                isNavigation: true,
                gap: 0,
                focus: 'center',
                pagination: false,
                arrows: false
            }
            carouselCounter.forEach((counter, indexCounter) => {
                carouselArray['carouselCounter' + index + 'i' + indexCounter] = new Splide(counter, confCounter);
                carouselArray['carousel' + index].sync(carouselArray['carouselCounter' + index + 'i' + indexCounter]);
            });
        }

        let carouselThumbnails = item.querySelectorAll('.pdw-carousel-thumbnails');
        if (carouselThumbnails.length > 0) {
            let confThumbnails = {
                perPage: 1,
                perMove: 1,
                type: 'loop',
                rewind: true,
                isNavigation: true,
                gap: 10,
                pagination: false,
                arrows: true,
                direction: 'ttb',
                fixedWidth: 100,
                fixedHeight: 100,
                height: '100vh'
            }
            carouselThumbnails.forEach((thumbnails, indexThumbnails) => {
                carouselArray['carouselThumbnails' + index + 'i' + indexThumbnails] = new Splide(thumbnails, confThumbnails);
                carouselArray['carousel' + index].sync(carouselArray['carouselThumbnails' + index + 'i' + indexThumbnails]);
            });
        }
    });

    Object.values(carouselArray).forEach(carouselItem => {
        carouselItem.mount();
    });

    let carousels = document.querySelectorAll('.pdw-carousel-accommodation');

    carousels.forEach(function (carousel) {
        let splide = new Splide(carousel, {
            type: 'slide',
            perPage: 1,
            gap: 32,
            pagination: false,
            arrows: true,
            rewind: true,
            autoplay: 3000,
            pauseOnHover: true,
            pauseOnFocus: true,
            padding: { left: 0, right: '40%' }
        });

        splide.mount();

        // Utiliser la classe du wrapper pour trouver le bon compteur
        let counterId = carousel.closest('.carousel-wrapper').classList[1]; // Récupère l'ID unique à partir de la classe du wrapper

        // Vérification que l'ID a bien été récupéré
        if (counterId) {
            let currentSlideElement = document.getElementById('current-slide-' + counterId);
            let totalSlidesElement = document.getElementById('total-slides-' + counterId);
            let prevArrow = document.querySelector('#arrow-' + counterId + ' .splide__arrow--prev');
            let nextArrow = document.querySelector('#arrow-' + counterId + ' .splide__arrow--next');

            if (currentSlideElement && totalSlidesElement) {
                totalSlidesElement.textContent = splide.length; // Nombre total de slides

                splide.on('move', function (newIndex) {
                    currentSlideElement.textContent = newIndex + 1; // Mettre à jour le slide actuel
                });

                // Gérer le clic sur les chevrons (précédent et suivant)
                let prevChevron = document.querySelector('.carousel-counter-' + counterId + ' .pdw-icon-chevron-left');
                let nextChevron = document.querySelector('.carousel-counter-' + counterId + ' .pdw-icon-chevron-right');

                if (prevChevron && nextChevron) {
                    // Simulation d'un clic sur la flèche précédente
                    prevChevron.addEventListener('click', function () {
                        if (prevArrow) {
                            prevArrow.click(); // Simule un clic sur la flèche gauche
                        }
                    });

                    // Simulation d'un clic sur la flèche suivante
                    nextChevron.addEventListener('click', function () {
                        if (nextArrow) {
                            nextArrow.click(); // Simule un clic sur la flèche droite
                        }
                    });
                }
            }
        } else {
            console.error("Le counterId n'a pas pu être récupéré.");
        }
    });
});